import './index.scss';
import {setTit} from '@/utils/settit';
const PassgerInformation = () => {
    return (
        <div className="container">
            <h2 >录音录像信息收集及隐私保护协议</h2>
            <p>发布日期：2021年11月1日</p>
            <p>更新日期：2021年11月1日</p>
            <p>为提升“{setTit()}”服务的安全性，更好地保障用户的安全，处理“{setTit()}”服务过程中的司乘纠纷，提升我们的服务品质，“{setTit()}”已上线录音录像功能。</p>
            <p className="bold">本协议将向您说明“{setTit()}”收集使用录音录像信息的情况，请您务必认真阅读本协议，在确认充分了解情况后慎重决定是否同意本协议。</p>
            <p>点击同意后，本协议生效，对您及“{setTit()}”均具有法律约束力。</p>
            <p className="bold">1.信息的收集</p>
            <p>1.1录像</p>
            <p>部分“{setTit()}”注册车辆内安装有录像设备（含对内摄像头及对外摄像头）。</p>
            <p>a)您使用“{setTit()}”的服务时，部分车辆内安装有录像设备（含对内摄像头及对外摄像头），后续您驾驶/乘坐安装有录像设备的车辆，“{setTit()}” 将通过对内摄像头收集您的录像信息，且后续行程不再做单独提示。 </p>
            <p>b)录像自车主接单时（预约订单自车主到达乘客起点时）起，至行程结束后1分钟止。乘客自进入此类车辆后至离开车辆时，可能将同时被采集录像信息。</p>
            <p>c)在车辆启动状态下，“{setTit()}”将通过对外摄像头收集车外录像及相应的位置信息。车主接单状态下的车外录像可能被用于辅助处理用户纠纷。车主接单状态以外的车外录像及相应的位置信息，“{setTit()}”不会将其与车主身份信息或车辆信息绑定使用。对于未与用户身份信息绑定的车外录像及相应位置信息，因其无法识别自然人身份，依照国家相关法律法规规定，将不被视为个人信息。</p>
            <p>1.2录音</p>
            <p>a)您使用“{setTit()}”的服务时，“{setTit()}”将通过APP或其他具备录音功能的软件或硬件录取您后续全部行程中的车内环境声音信息（包括您及车上人员交谈或肢体动作产生的声音），且后续行程不再做单独提示。受技术条件影响，在不同城市上线录音功能的时间不同，具体以APP上显示的录音状态为准。</p>
            <p>b)录音自订单行程开始时起（预约订单自车主到达乘客起点时起），至行程结束后适当时间停止（具体以APP上显示的录音状态为准）。乘客自进入车辆后至离开车辆时，可能将同时被采集录音信息。</p>
            <p>1.3录音应当仅在车主、乘客均同意的情况下开启，如乘客使用的APP版本未及时更新，无法对录音进行授权，则不会开启录音。但是，在“拼车”场景下，获得车主及部分乘客用户同意后，录音录像将开启。</p>
            <p>1.4如果您是代他人叫车，在代叫车前请务必告知被代叫车人行程内录音录像信息收集情况，并征得被代叫车人同意后，方可为其叫车。</p>
            <p className="bold">2.信息的保存</p>
            <p>2.1为保障车主与乘客用户的隐私，“{setTit()}”将对录音及车内录像进行加密保存，车主或乘客用户无法自行下载、调取或播放录音录像。</p>
            <p>2.2录音保存在“{setTit()}”的服务器中，保存期限约定为7日。如遇差评、投诉、尚未处理完毕的纠纷等，“{setTit()}”将适当延长录音保存期限。</p>
            <p>2.3车内录像（如有）在车载设备内的保存期限受车载设备内存限制，当存储空间已满时会自动删除最早的录像。“{setTit()}”因本协议明确列明的使用场景而调取的录像，保存在“{setTit()}”服务器中。因使用场景不同，保存期限为 15 日至 6 个自然月不等（在满足特定使用场景后立即删除）。如遇差评、投诉、尚未处理完毕的纠纷等，“{setTit()}”将适当延长录音保存期限。</p>
            <p>2.4“{setTit()}”为用户提供已完成订单的行程录音录像删除服务；对无纠纷和投诉等需求的订单行程录音录像删除申请，在取得乘客和车主确认后予以处理。</p>
            <p className="bold">3.录音录像信息将用于以下明确列明的使用情形：</p>
            <p>3.1在征得车主和乘客同意的情况下，作为处理用户纠纷的依据。</p>
            <p>3.2为维护用户或其他个人的人身财产安全等重大合法利益，或情况紧急又很难得到用户同意的。</p>
            <p>3.3用于抽查检测用户是否存在违反用户规则的行为。</p>
            <p>3.4用户系统分析，设计、开发、应用保护用户安全的辅助工具或产品。</p>
            <p>3.5根据与您签订和履行相关协议或其他文件所必须的。</p>
            <p>在以上使用情形中，“{setTit()}”会在必要限度内对行程录音采取技术措施使录音可识别录音内容但无法识别用户身份，如对音频信息的基频进行改变等；“{setTit()}”会在必要限度内对行程录像采取技术措施对乘客和驾驶员面部识别特征模糊化处理，如采取检测技术在视频中定位乘客面部位置，对面部识别特征遮挡处理等。</p>
            <p className="bold">4.“{setTit()}”将严格保护用户个人信息安全，但在以下情况时，我们可能会收集、使用您的相关信息而无需征得您的授权同意：</p>
            <p className="bold">4.1相关行政机关、司法机关等依据法定程序调取。</p>
            <p className="bold">4.2与国家安全、国防安全相关。</p>
            <p className="bold">4.3与公共安全、公共卫生、重大公共利益相关的。</p>
            <p className="bold">4.4与犯罪侦查、起诉、审判和判决执行等相关的。</p>
            <p className="bold">4.5根据法律法规等规定的其他情形。</p>
            <p className="bold">5.录音录像设备、用户使用的手机等故障、网络状态不稳定、APP版本过旧以及不可抗力等因素均可能导致录音录像失败，您对此表示理解，如遇此类问题，“{setTit()}”不需承担责任。</p>
            <p className="bold">6.“{setTit()}”将严格按照本协议约定收集、使用用户录音录像信息。本协议对相关内容未作明确约定的，以《隐私政策》为准。</p>
        </div>

    )
}
export default PassgerInformation